//imports
import {
    JIRA_SUMMARY_SEARCH_REQUEST,
    JIRA_SUMMARY_SEARCH_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    developers: []
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case JIRA_SUMMARY_SEARCH_REQUEST:
            return { ...state, loading: true }

        case JIRA_SUMMARY_SEARCH_RESULT:
            return { ...state, loading: false, developers: action.payload }

        case CLEAR_REDUX:
            return ["", "JIRA_SUMMARY"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};